import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../../../core/Error.js";
import { WGLVVFlag as e, WGLVVTarget as i, WGLGeometryType as s } from "../enums.js";
import { isMapAligned as a } from "../mesh/templates/meshUtils.js";

function r(t, s) {
  var a = e.SIZE_FIELD_STOPS | e.SIZE_MINMAX_VALUE | e.SIZE_SCALE_STOPS | e.SIZE_UNIT_VALUE,
      r = (t & (i.FIELD_TARGETS_OUTLINE | i.MINMAX_TARGETS_OUTLINE | i.SCALE_TARGETS_OUTLINE | i.UNIT_TARGETS_OUTLINE)) >>> 4;
  return s.isOutline || s.isOutlinedFill ? a & r : a & ~r;
}

var n = 0,
    v = 8,
    o = 7,
    l = 8,
    h = 11,
    S = 11,
    u = 12,
    d = 13,
    V = 14,
    c = 15,
    p = 15,
    g = 16,
    z = 17,
    m = 18,
    y = 19,
    E = 20,
    T = 21,
    M = 22;

function L(t, e) {
  switch (t) {
    case s.FILL:
      return x.from(e);

    case s.LINE:
      return B.from(e);

    case s.MARKER:
      return U.from(e);

    case s.TEXT:
      return R.from(e);

    case s.LABEL:
      return b.from(e);

    default:
      throw new Error("Unable to createMaterialKey for unknown geometryType ".concat(t));
  }
}

function F(t) {
  switch (_.load(t).geometryType) {
    case s.MARKER:
      return new U(t);

    case s.FILL:
      return new x(t);

    case s.LINE:
      return new B(t);

    case s.TEXT:
      return new R(t);

    case s.LABEL:
      return new b(t);
  }
}

var _ = /*#__PURE__*/function () {
  function _(t) {
    _classCallCheck(this, _);

    this._data = 0, this._data = t;
  }

  _createClass(_, [{
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(t) {
      this._data = t;
    }
  }, {
    key: "geometryType",
    get: function get() {
      return this.bits(l, h);
    },
    set: function set(t) {
      this.setBits(t, l, h);
    }
  }, {
    key: "mapAligned",
    get: function get() {
      return !!this.bit(E);
    },
    set: function set(t) {
      this.setBit(E, t);
    }
  }, {
    key: "sdf",
    get: function get() {
      return !!this.bit(S);
    },
    set: function set(t) {
      this.setBit(S, t);
    }
  }, {
    key: "pattern",
    get: function get() {
      return !!this.bit(u);
    },
    set: function set(t) {
      this.setBit(u, t);
    }
  }, {
    key: "textureBinding",
    get: function get() {
      return this.bits(n, v);
    },
    set: function set(t) {
      this.setBits(t, n, v);
    }
  }, {
    key: "geometryTypeString",
    get: function get() {
      switch (this.geometryType) {
        case s.FILL:
          return "fill";

        case s.MARKER:
          return "marker";

        case s.LINE:
          return "line";

        case s.TEXT:
          return "text";

        case s.LABEL:
          return "label";

        default:
          throw new t("Unable to handle unknown geometryType: ".concat(this.geometryType));
      }
    }
  }, {
    key: "setBit",
    value: function setBit(t, e) {
      var i = 1 << t;
      e ? this._data |= i : this._data &= ~i;
    }
  }, {
    key: "bit",
    value: function bit(t) {
      return (this._data & 1 << t) >> t;
    }
  }, {
    key: "setBits",
    value: function setBits(t, e, i) {
      for (var _s = e, _a = 0; _s < i; _s++, _a++) {
        this.setBit(_s, 0 != (t & 1 << _a));
      }
    }
  }, {
    key: "bits",
    value: function bits(t, e) {
      var i = 0;

      for (var _s2 = t, _a2 = 0; _s2 < e; _s2++, _a2++) {
        i |= this.bit(_s2) << _a2;
      }

      return i;
    }
  }, {
    key: "hasVV",
    value: function hasVV() {
      return !1;
    }
  }, {
    key: "setVV",
    value: function setVV(t, e) {}
  }, {
    key: "getVariation",
    value: function getVariation() {
      return {
        mapAligned: this.mapAligned,
        pattern: this.pattern,
        sdf: this.sdf
      };
    }
  }, {
    key: "getVariationHash",
    value: function getVariationHash() {
      return this._data & ~(o & this.textureBinding);
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }]);

  return _;
}();

_.shared = new _(0);

var I = function I(t) {
  return /*#__PURE__*/function (_t) {
    _inherits(_class, _t);

    var _super = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass(_class, [{
      key: "vvSizeMinMaxValue",
      get: function get() {
        return 0 !== this.bit(g);
      },
      set: function set(t) {
        this.setBit(g, t);
      }
    }, {
      key: "vvSizeScaleStops",
      get: function get() {
        return 0 !== this.bit(z);
      },
      set: function set(t) {
        this.setBit(z, t);
      }
    }, {
      key: "vvSizeFieldStops",
      get: function get() {
        return 0 !== this.bit(m);
      },
      set: function set(t) {
        this.setBit(m, t);
      }
    }, {
      key: "vvSizeUnitValue",
      get: function get() {
        return 0 !== this.bit(y);
      },
      set: function set(t) {
        this.setBit(y, t);
      }
    }, {
      key: "hasVV",
      value: function hasVV() {
        return _get(_getPrototypeOf(_class.prototype), "hasVV", this).call(this) || this.vvSizeMinMaxValue || this.vvSizeScaleStops || this.vvSizeFieldStops || this.vvSizeUnitValue;
      }
    }, {
      key: "setVV",
      value: function setVV(t, i) {
        _get(_getPrototypeOf(_class.prototype), "setVV", this).call(this, t, i);

        var s = r(t, i) & t;
        this.vvSizeMinMaxValue = !!(s & e.SIZE_MINMAX_VALUE), this.vvSizeFieldStops = !!(s & e.SIZE_FIELD_STOPS), this.vvSizeUnitValue = !!(s & e.SIZE_UNIT_VALUE), this.vvSizeScaleStops = !!(s & e.SIZE_SCALE_STOPS);
      }
    }]);

    return _class;
  }(t);
},
    O = function O(t) {
  return /*#__PURE__*/function (_t2) {
    _inherits(_class2, _t2);

    var _super2 = _createSuper(_class2);

    function _class2() {
      _classCallCheck(this, _class2);

      return _super2.apply(this, arguments);
    }

    _createClass(_class2, [{
      key: "vvRotation",
      get: function get() {
        return 0 !== this.bit(c);
      },
      set: function set(t) {
        this.setBit(c, t);
      }
    }, {
      key: "hasVV",
      value: function hasVV() {
        return _get(_getPrototypeOf(_class2.prototype), "hasVV", this).call(this) || this.vvRotation;
      }
    }, {
      key: "setVV",
      value: function setVV(t, i) {
        _get(_getPrototypeOf(_class2.prototype), "setVV", this).call(this, t, i), this.vvRotation = !i.isOutline && !!(t & e.ROTATION);
      }
    }]);

    return _class2;
  }(t);
},
    A = function A(t) {
  return /*#__PURE__*/function (_t3) {
    _inherits(_class3, _t3);

    var _super3 = _createSuper(_class3);

    function _class3() {
      _classCallCheck(this, _class3);

      return _super3.apply(this, arguments);
    }

    _createClass(_class3, [{
      key: "vvColor",
      get: function get() {
        return 0 !== this.bit(d);
      },
      set: function set(t) {
        this.setBit(d, t);
      }
    }, {
      key: "hasVV",
      value: function hasVV() {
        return _get(_getPrototypeOf(_class3.prototype), "hasVV", this).call(this) || this.vvColor;
      }
    }, {
      key: "setVV",
      value: function setVV(t, i) {
        _get(_getPrototypeOf(_class3.prototype), "setVV", this).call(this, t, i), this.vvColor = !i.isOutline && !!(t & e.COLOR);
      }
    }]);

    return _class3;
  }(t);
},
    f = function f(t) {
  return /*#__PURE__*/function (_t4) {
    _inherits(_class4, _t4);

    var _super4 = _createSuper(_class4);

    function _class4() {
      _classCallCheck(this, _class4);

      return _super4.apply(this, arguments);
    }

    _createClass(_class4, [{
      key: "vvOpacity",
      get: function get() {
        return 0 !== this.bit(V);
      },
      set: function set(t) {
        this.setBit(V, t);
      }
    }, {
      key: "hasVV",
      value: function hasVV() {
        return _get(_getPrototypeOf(_class4.prototype), "hasVV", this).call(this) || this.vvOpacity;
      }
    }, {
      key: "setVV",
      value: function setVV(t, i) {
        _get(_getPrototypeOf(_class4.prototype), "setVV", this).call(this, t, i), this.vvOpacity = !i.isOutline && !!(t & e.OPACITY);
      }
    }]);

    return _class4;
  }(t);
};

var x = /*#__PURE__*/function (_A) {
  _inherits(x, _A);

  var _super5 = _createSuper(x);

  function x() {
    _classCallCheck(this, x);

    return _super5.apply(this, arguments);
  }

  _createClass(x, [{
    key: "getVariation",
    value: function getVariation() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(x.prototype), "getVariation", this).call(this)), {}, {
        dotDensity: this.dotDensity,
        outlinedFill: this.outlinedFill,
        simple: this.simple,
        vvColor: this.vvColor,
        vvOpacity: this.vvOpacity,
        vvSizeFieldStops: this.vvSizeFieldStops,
        vvSizeMinMaxValue: this.vvSizeMinMaxValue,
        vvSizeScaleStops: this.vvSizeScaleStops,
        vvSizeUnitValue: this.vvSizeUnitValue
      });
    }
  }, {
    key: "dotDensity",
    get: function get() {
      return !!this.bit(p);
    },
    set: function set(t) {
      this.setBit(p, t);
    }
  }, {
    key: "simple",
    get: function get() {
      return !!this.bit(M);
    },
    set: function set(t) {
      this.setBit(M, t);
    }
  }, {
    key: "outlinedFill",
    get: function get() {
      return !!this.bit(T);
    },
    set: function set(t) {
      this.setBit(T, t);
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }, {
    key: "from",
    value: function from(t) {
      var e = this.load(0);
      return e.geometryType = s.FILL, e.dotDensity = "dot-density" === t.stride.fill, e.simple = "simple" === t.stride.fill, e.outlinedFill = t.isOutlinedFill, e.dotDensity || e.setVV(t.vvFlags, t), e.data;
    }
  }]);

  return x;
}(A(f(I(_))));

x.shared = new x(0);

var U = /*#__PURE__*/function (_A2) {
  _inherits(U, _A2);

  var _super6 = _createSuper(U);

  function U() {
    _classCallCheck(this, U);

    return _super6.apply(this, arguments);
  }

  _createClass(U, [{
    key: "getVariation",
    value: function getVariation() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(U.prototype), "getVariation", this).call(this)), {}, {
        vvColor: this.vvColor,
        vvRotation: this.vvRotation,
        vvOpacity: this.vvOpacity,
        vvSizeFieldStops: this.vvSizeFieldStops,
        vvSizeMinMaxValue: this.vvSizeMinMaxValue,
        vvSizeScaleStops: this.vvSizeScaleStops,
        vvSizeUnitValue: this.vvSizeUnitValue
      });
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }, {
    key: "from",
    value: function from(t) {
      var e = this.load(0);
      return e.geometryType = s.MARKER, e.setVV(t.vvFlags, t), e.data;
    }
  }]);

  return U;
}(A(f(O(I(_)))));

U.shared = new U(0);

var B = /*#__PURE__*/function (_A3) {
  _inherits(B, _A3);

  var _super7 = _createSuper(B);

  function B() {
    _classCallCheck(this, B);

    return _super7.apply(this, arguments);
  }

  _createClass(B, [{
    key: "getVariation",
    value: function getVariation() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(B.prototype), "getVariation", this).call(this)), {}, {
        vvColor: this.vvColor,
        vvOpacity: this.vvOpacity,
        vvSizeFieldStops: this.vvSizeFieldStops,
        vvSizeMinMaxValue: this.vvSizeMinMaxValue,
        vvSizeScaleStops: this.vvSizeScaleStops,
        vvSizeUnitValue: this.vvSizeUnitValue
      });
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }, {
    key: "from",
    value: function from(t) {
      var e = this.load(0);
      return e.geometryType = s.LINE, e.setVV(t.vvFlags, t), e.data;
    }
  }]);

  return B;
}(A(f(I(_))));

B.shared = new B(0);

var R = /*#__PURE__*/function (_A4) {
  _inherits(R, _A4);

  var _super8 = _createSuper(R);

  function R() {
    _classCallCheck(this, R);

    return _super8.apply(this, arguments);
  }

  _createClass(R, [{
    key: "getVariation",
    value: function getVariation() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(R.prototype), "getVariation", this).call(this)), {}, {
        vvColor: this.vvColor,
        vvOpacity: this.vvOpacity,
        vvRotation: this.vvRotation,
        vvSizeFieldStops: this.vvSizeFieldStops,
        vvSizeMinMaxValue: this.vvSizeMinMaxValue,
        vvSizeScaleStops: this.vvSizeScaleStops,
        vvSizeUnitValue: this.vvSizeUnitValue
      });
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }, {
    key: "from",
    value: function from(t) {
      var e = this.load(0);
      return e.geometryType = s.TEXT, e.setVV(t.vvFlags, t), e.data;
    }
  }]);

  return R;
}(A(f(O(I(_)))));

R.shared = new R(0);

var b = /*#__PURE__*/function (_I) {
  _inherits(b, _I);

  var _super9 = _createSuper(b);

  function b() {
    _classCallCheck(this, b);

    return _super9.apply(this, arguments);
  }

  _createClass(b, [{
    key: "getVariation",
    value: function getVariation() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(b.prototype), "getVariation", this).call(this)), {}, {
        vvSizeFieldStops: this.vvSizeFieldStops,
        vvSizeMinMaxValue: this.vvSizeMinMaxValue,
        vvSizeScaleStops: this.vvSizeScaleStops,
        vvSizeUnitValue: this.vvSizeUnitValue
      });
    }
  }], [{
    key: "load",
    value: function load(t) {
      var e = this.shared;
      return e.data = t, e;
    }
  }, {
    key: "from",
    value: function from(t) {
      var e = this.load(0);
      return e.geometryType = s.LABEL, e.setVV(t.vvFlags, t), e.mapAligned = a(t.placement), e.data;
    }
  }]);

  return b;
}(I(_));

b.shared = new b(0);
export { x as FillMaterialKey, b as LabelMaterialKey, B as LineMaterialKey, U as MarkerMaterialKey, _ as MaterialKeyBase, R as TextMaterialKey, L as createMaterialKey, r as getSizeFlagsMask, F as hydrateMaterialKey };